import { TimeEntry, Project } from '../../../types';
import { getWeekNumber, weekToDateRange } from '../../../lib/utils';

export function parseWeekFilter(val: string, year: number): { from: string; to: string } | null {
  const week = parseInt(val, 10);
  if (!val || isNaN(week) || week < 1 || week > 53) return null;
  return weekToDateRange(year, week);
}

export function groupEntriesByWeekAndDate(entries: TimeEntry[]): Record<number, Record<string, TimeEntry[]>> {
  const grouped: Record<number, Record<string, TimeEntry[]>> = {};
  for (const entry of entries) {
    const dateStr = entry.date.slice(0, 10);
    const week = getWeekNumber(dateStr);
    if (!grouped[week]) grouped[week] = {};
    (grouped[week][dateStr] ??= []).push(entry);
  }
  return grouped;
}

export function getSortedWeekNumbers(grouped: Record<number, unknown>): number[] {
  return Object.keys(grouped).map(Number).sort((a, b) => b - a);
}

export function getPhaseName(projects: Project[], entry: Pick<TimeEntry, 'projectId' | 'phaseId'>): string {
  return projects.find((p) => p.id === entry.projectId)?.type?.phases
    .find((ph) => ph.id === entry.phaseId)?.name ?? '—';
}
